import React from 'react';
import { Paper, Typography } from '@mui/material';

const AccessDenied = ({ message = "Your account doesn't have access to this page." }) => (
    <Paper variant="outlined" sx={{ py: 6, px: 3, textAlign: 'center', maxWidth: 560, mx: 'auto', mt: 4 }}>
        <Typography variant="h5" component="h2">
            No access
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 1 }}>
            {message} Ask your All City Towing contact to add it to your vendor permissions.
        </Typography>
    </Paper>
);

export default AccessDenied;
